import { render, staticRenderFns } from "./SensitiveContentModal.vue?vue&type=template&id=9aa7b3c8&scoped=true"
import script from "./SensitiveContentModal.vue?vue&type=script&lang=js"
export * from "./SensitiveContentModal.vue?vue&type=script&lang=js"
import style0 from "./SensitiveContentModal.vue?vue&type=style&index=0&id=9aa7b3c8&prod&scoped=true&lang=css"
import style1 from "./SensitiveContentModal.vue?vue&type=style&index=1&id=9aa7b3c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa7b3c8",
  null
  
)

export default component.exports